import Title from "../Title";
import Button from "../../Button";
import { useContext, useEffect, useState } from "react";
import { leftBoxContext } from "../Frameleft.js";
import { getprofileapi } from "../../../../network/api/user.js"
import {  createOrder2} from "../../../../network/api/order.js";
import { useTranslation } from "react-i18next";

function PaymentCheckout({ fees,couponCode,finalPriceWithDiscountAndFees }) {
  const {t} = useTranslation()
  const [hasSubmitted, setHasSubmitted] = useState(false);
  const [userWallet, setUserWallet] = useState("")
  const [payCash, setPayCash] = useState("");

  useEffect(() => {
    getprofileapi().then((response) => {
      setUserWallet(response.response.wallet)
    })
  }, [])


  

  const { selectedAddress, name, phone, city, area, address, house, cartItems, totalPrice } = useContext(leftBoxContext);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (payCash === "wallet") {
      if (finalPriceWithDiscountAndFees > userWallet) {
        setError(t("errors.wallet_exceed"));
        setTimeout(() => {
          setError("");
        }, 2000);
        setHasSubmitted(false);
        return;
      }
    }
    if (cartItems.length === 0) {
      setError(t("errors.empty_cart"));
      setTimeout(() => {
        setError("");
      }, 2000);
      setHasSubmitted(false);
      return;
    }
    if (hasSubmitted) {
      return;
    }
    setHasSubmitted(true);
    if (payCash !== "cash" && payCash !== "card" && payCash !== "wallet") {
      setError(t("errors.choose_payment"));
      setTimeout(() => {
        setError("");
      }, 2000);
      setHasSubmitted(false);
      return;
    }
    ////////////////////////////////create order
    if (selectedAddress === "addNewAddress") {
      await createOrder2({
        name,
        cartItems,
        phone,
        city,
        area,
        address,
        house,
        payment: payCash,
        couponCode,
        // fees:fees,
        totalPrice: finalPriceWithDiscountAndFees,
      })
        .then((response) => {
          localStorage.removeItem('couponCode');
          localStorage.removeItem('discountPercentage');
          window.location.href = `${response.data.response.url}`;
        })
        .catch((err) => {
          setError(err.message);
        });
    } else {
      await createOrder2({
        name: selectedAddress.fullName,
        cartItems,
        phone: selectedAddress.mobileNumber,
        city: selectedAddress.city,
        area: selectedAddress.area,
        address: selectedAddress.address,
        house: selectedAddress.house,
        payment: payCash,
        couponCode:couponCode,
        // fees:fees,
        totalPrice: finalPriceWithDiscountAndFees,
      })
        .then((response) => {
          localStorage.removeItem('couponCode');
          localStorage.removeItem('discountPercentage');
          window.location.href = `${response.data.response.url}`;
        })
        .catch((err) => {
          setError(err.message);
        });
    }
  };
 
  

  return (
    <>
      <div className="payment mt-0 ">
        <Title
           title={t("payment.title")}
           text={t("payment.subtitle")}
        />
        {/* visa */}
        <div className="credit-card">
          <label htmlFor="card" className="payment-label d-flex">
            <div>
              <input
                style={{ border: "2px solid black" }}
                type="radio"
                name="card"
                id="card"
                value="card"
                checked={payCash === "card"}
                onChange={() => setPayCash("card")}
              />
            </div>
            <div className="d-flex flex-column  gap-0 ">
              <p className=" m-0  p-0 ">{t("payment.methods.card.title")}</p>
              <span className=" m-0  p-0 ">  {t("payment.methods.card.subtitle")}</span>
            </div>
          </label>
        </div>
        {/* cash */}
        <div className="cash">
          <label htmlFor="cash" className="payment-label d-flex">
            <input
              type="radio"
              className="mt-3"
              style={{ border: "2px solid black" }}
              name="cash"
              id="cash"
              value="cash"
              checked={payCash === "cash"}
              onChange={() => setPayCash("cash")}
            />
            <div className=" d-flex  flex-column  gap-0 ">
              <p className=" m-0">{t("payment.methods.cash.title")}</p>
              <span>{t("payment.methods.cash.subtitle")}</span>
            </div>
          </label>
        </div>
        {/* wallet */}
        <div className="walleet">
          <label htmlFor="wallet" className="payment-label d-flex">
            <input
              className=" mt-1"
              type="radio"
              style={{ border: "2px solid black" }}
              name=""
              id="wallet"
              value="wallet"
              checked={payCash === "wallet"}
              onChange={() => setPayCash("wallet")}
            />
            <div style={{ lineHeight: "20px" }} className="d-flex flex-column gap-0">
              <p style={{ fontWeight: "bold", }} className="mb-2">  {t("payment.methods.wallet.title")}</p>
              <span>{t("payment.methods.wallet.subtitle")}</span>
            </div>
          </label>
        </div>
      </div>
      <form action="" method="" onSubmit={handleSubmit}>
        {error && (
          <div className="alert alert-danger" role="alert">
            {error}
          </div>
        )}
        <Button  text={t("payment.button")} />
      </form>
    </>
  );
}
export default PaymentCheckout;
